import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { Activity } from "lucide-mui";

/** Marks a collection a signal workflow feeds: its entries are signals to use or disqualify. */
export default function SignalListChip({ onClick }: { onClick?: () => void }) {
  return (
    <Tooltip title="Filled by a signal workflow. Decide on its companies in the Prospects inbox.">
      <Chip
        size="small"
        color="info"
        variant="outlined"
        icon={<Activity />}
        label="Signal collection"
        onClick={onClick}
      />
    </Tooltip>
  );
}
